import axios from './axiosConfig';
import { AxiosPromise } from 'axios';
import { ILevelTestApplicant, ILevelTestApplicantParam } from '../models/levelTestApplicant.model';
import qs from 'qs';

export const getLevelTestApplicantList = (param: ILevelTestApplicantParam): AxiosPromise<ILevelTestApplicant[]> => {
  const qsParam = qs.stringify(param);
  return axios.get(`/api/schedule/leveltest?${qsParam}`);
};
